//modal window
document.addEventListener('DOMContentLoaded', function () {

  const items   = document.querySelectorAll('.opsodis__item');
  const modals  = document.querySelectorAll('.opsodis-detail');
  const closes  = document.querySelectorAll('.navi-close');

  items.forEach(item => {

    item.addEventListener('click', function () {

      const id = item.id;           // modal_1
      const number = id.split('_')[1]; // 1

      modals.forEach(modal => modal.classList.remove('is-active'));

      const target = document.querySelector('.__content' + number);

      if (target) {
        target.classList.add('is-active');
        document.body.style.overflow = 'hidden';
      }

    });

  });

  closes.forEach(close => {

    close.addEventListener('click', function () {

      modals.forEach(modal => modal.classList.remove('is-active'));
      document.body.style.overflow = '';

    });

  });

  modals.forEach(modal => {

    modal.addEventListener('click', function (e) {

      if (e.target === modal) {
        modal.classList.remove('is-active');
        document.body.style.overflow = '';
      }

    });

  });

});

//modal swiper
const opsodisSwiper = new Swiper('#opsodis .swiper', {
spaceBetween: 200,
grabCursor: true,
slidesPerView: 1,
loop:true,
pagination: {
    el: '.swiper-pagination',
    clickable: true,
},
navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
},

})

// swiper
const soundSwiper = new Swiper('#sound .swiper', {
spaceBetween: 120,
grabCursor: true,
slidesPerView: 1,
pagination: {
    el: '.swiper-pagination',
    clickable: true,
},
navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
},

})

const mySwiper = new Swiper('#life .swiper', {
    spaceBetween: 37,
    grabCursor: true,
    slidesPerView: 'auto',
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    breakpoints: {
        768: {
        spaceBetween: 24,
        },
        1025: {
        spaceBetween: 54,
        }
    },
    });

// size swiper
const sizeSwiper = new Swiper('.size__detail', {
  slidesPerView: 1,
  grabCursor: true,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
});

document.addEventListener('DOMContentLoaded', function () {

  const switchItems = document.querySelectorAll('.size__switch_item');

  switchItems.forEach((item, index) => {

    item.addEventListener('click', function () {

      sizeSwiper.slideTo(index);

      switchItems.forEach(i => i.classList.remove('is-active'));
      item.classList.add('is-active');

    });

  });

});

sizeSwiper.on('slideChange', function () {

  const activeIndex = sizeSwiper.activeIndex;
  const switchItems = document.querySelectorAll('.size__switch_item');

  switchItems.forEach(i => i.classList.remove('is-active'));
  switchItems[activeIndex].classList.add('is-active');

});

// video
document.querySelectorAll('.video').forEach(wrapper => {

  const video = wrapper.querySelector('.video__player');

  wrapper.addEventListener('click', function () {

    if (video.paused) {

      video.play();
      video.setAttribute('controls', true);
      wrapper.classList.add('is-playing');

    } else {

      video.pause();

    }

  });

});

// product floating
document.addEventListener("DOMContentLoaded", function () {

  const floating = document.querySelector(".product-floating");
  const detail   = document.getElementById("Detail");
  const footer   = document.querySelector("footer");

  if (!floating || !detail || !footer) return;

  function checkPosition() {

    const scrollY = window.scrollY;
    const windowH = window.innerHeight;

    const detailTop = detail.offsetTop;
    const detailHeight = detail.offsetHeight;

    const footerTop = footer.offsetTop;

    const passedDetail =
      scrollY + windowH > detailTop + 2000;

    const reachedFooter =
      scrollY + windowH > footerTop;

    if (passedDetail && !reachedFooter) {
      floating.classList.add("is-show");
    } else {
      floating.classList.remove("is-show");
    }
  }

  window.addEventListener("scroll", checkPosition);
  window.addEventListener("load", checkPosition);

});
